import React from 'react';
import styled from 'styled-components';
import { useUserPolicy } from '../../../../user-policy';

const MenuUserNameWrapper = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: #262626;
  margin: 0 16px;
`;

function MenuUserName() {
  const { userAccount } = useUserPolicy();
  if (!userAccount) {
    return null;
  }

  return <MenuUserNameWrapper>{userAccount.name}</MenuUserNameWrapper>;
}

export default MenuUserName;
